// extracted by mini-css-extract-plugin
export default {"errorCode":"ErrorCodesEditForm_errorCode__4uosp","submitButtons":"ErrorCodesEditForm_submitButtons__FS7hT"};